// extracted by mini-css-extract-plugin
module.exports = {"container":"packages-primitives-Spinner-style__container--1kWQx","spinner-default":"packages-primitives-Spinner-style__spinner-default--3u4uB"};